import React, { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';

import TableContainer from '../../../../../Components/Common/TableContainer';

import { columns } from './columns';
import { getConversions } from '../../slice';
import { useMatch } from 'react-router';

export const TopUp: React.FC = () => {
  const { conversions } = useAppSelector((state) => state.userDetails);

  const dispatch = useAppDispatch();

  const match = useMatch('/users/:id/*');
  const userId = match?.params.id;

  useEffect(() => {
    dispatch(getConversions(Number(userId)));
  }, []);

  return (
    <>
      <TableContainer
        columns={columns}
        data={conversions || []}
        divClass='table-responsive table-card mb-1'
        tableClass='align-middle table-nowrap'
        theadClass='table-light text-muted'
      />
    </>
  );
};
